import UserIdIcon from 'assets/personal_zone/UserId_g.svg';
import SaleIcon from 'assets/personal_zone/Sale_g.svg';
import WalletIcon from 'assets/personal_zone/wallet_g.svg';
import LikeIcon from 'assets/personal_zone/like_g.svg';
import HistoryIcon from 'assets/personal_zone/history_g.svg';
import LogoutIcon from 'assets/personal_zone/logout.svg';
import * as routes from 'constants/routes';
import { useTranslations } from 'common/hooks/useTranslations';
import membershipCertificateIcon from 'assets/personal_zone/certificate3.svg';

export const USER_INFO_MENU_IDS = {
  PERSONAL_INFO: 'personal-info',
  COUPONS: 'coupons',
  SAVINGS: 'savings',
  FAVORITES: 'favorites',
  ORDER_HISTORY: 'order-history',
  LOGOUT: 'logout',
  MEMBERSHIP_CERTIFICATE: 'membership-certificate',
};

const USER_INFO_MENU_CONFIG_BASE = [
  { 
    id: USER_INFO_MENU_IDS.PERSONAL_INFO, 
    labelKey: 'personal_zone_personal_info_title', 
    icon: UserIdIcon, 
    path: routes.user_info_routes.personal_info 
  },
  { 
    id: USER_INFO_MENU_IDS.COUPONS, 
    labelKey: 'personal_zone_coupons_title', 
    icon: SaleIcon, 
    path: routes.user_info_routes.coupons 
  },
  // { 
  //   id: USER_INFO_MENU_IDS.SAVINGS, 
  //   labelKey: '...', 
  //   icon: WalletIcon, 
  //   path: routes.user_info_routes.savings 
  // },
  { 
    id: USER_INFO_MENU_IDS.FAVORITES, 
    labelKey: 'personal_zone_favorites_title', 
    icon: LikeIcon, 
    path: routes.user_info_routes.favorites 
  },
  // { 
  //   id: USER_INFO_MENU_IDS.ORDER_HISTORY, 
  //   labelKey: '...', 
  //   icon: HistoryIcon, 
  //   path: routes.user_info_routes.order_history 
  // },
  { 
    id: USER_INFO_MENU_IDS.MEMBERSHIP_CERTIFICATE, 
    labelKey: 'personal_zone_membership_certificate_title', 
    icon: membershipCertificateIcon, 
    path: routes.user_info_routes.membership_certificate 
  },
  { 
    id: USER_INFO_MENU_IDS.LOGOUT, 
    labelKey: 'personal_zone_logout_title', 
    icon: LogoutIcon 
  },
];

export const useUserInfoMenuConfig = () => {
  const { translate } = useTranslations();
  return USER_INFO_MENU_CONFIG_BASE.map(({ labelKey, ...rest }) => ({
    ...rest,
    label: translate(labelKey),
  }));
};

export const USER_INFO_MENU_CONFIG = USER_INFO_MENU_CONFIG_BASE;

export const COUPON_TABS = {
  PAID: 'paid',
  DOWNLOADED: 'downloaded',
}

export const GENDER = {
  MALE: 2,
  FEMALE: 1,
}

export const COUPON_STATUS = {
  PENDING: 'pending',
  SUCCESS: 'success',
  REFUND: 'refund',
  PARTIAL_REFUND: 'partial_refund',
  IN_PROGRESS_REQUEST: 'in_progress_request',
  NOT_CANCELLABLE: 'not_cancellable',
  EXPIRED: 'expired',
  PARTIALLY_USED: 'partially_used',
  FULLY_USED: 'fully_used',
};

export const COUPON_FILTER = {
  AVAILABLE: 'available',
  CANCELLED: 'cancelled',
  ARCHIVED: 'archived',
};

export const STATUS_MAP = {
  1: COUPON_STATUS.PENDING,
  2: COUPON_STATUS.SUCCESS,
  3: COUPON_STATUS.REFUND,
  4: COUPON_STATUS.PARTIAL_REFUND,
  5: COUPON_STATUS.IN_PROGRESS_REQUEST,
  6: COUPON_STATUS.NOT_CANCELLABLE,
  7: COUPON_STATUS.EXPIRED,
  8: COUPON_STATUS.PARTIALLY_USED,
  9: COUPON_STATUS.FULLY_USED,
};

export const SUCCESS_COUPON_STATUS = 2;

export const ITEMS_PER_PAGE = 100;

export const TOOLTIP_MODE = {
  DEFAULT: 'default',
  LIGHT: 'light',
};

export const TOOLTIP_PLACEMENT = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
};

export const FILTER_BENEFITS_TYPES = {
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
  ARCHIVED: 'archived',
}



export const OTP_PROCESS = {
  LOGIN: 'login',
  REGISTER: 'register',
  VERIFY: 'verify',
  EDIT_USER_INFORMATION: 'editUserInformation',
}